import styled from "styled-components";

export const Button = styled.button`
  border: 1px solid grey;
  background: none;
  color: red; 
`;

export const SectionName = styled.div`
  width: 100%;
  font-size: 1.5em;
  line-height: 1.6em;
  padding-top: 0.2em;
  padding-bottom: 0.2em;
  border: 1 solid green;
  background-color: #19af89;
`;

export const SideNavIcon = styled.span`
  font-size: 1em;
  cursor: pointer;
  padding-left: 1em;
  padding-right: 1em;
`;

export const Link = styled.a`
  margin: 1em;
  color: blue;
  text-decoration: underline;
`;

export const Image = styled.img`
  margin: 1em;
  padding: 1em;
  border-radius: 2em;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
`;

